<script lang="ts">
	import { closeOverlay } from "overlay"
	import { Responsive } from "responsive"
	import { COURT_PORTAL_URL } from "../../../../types/consts"

	let isMobile = $derived(Responsive.isMobile)

	function openCourtPortal() {
		window.location.href = COURT_PORTAL_URL
	}
</script>

<div id="court-portal-invite" class:isMobile>
	<div class="flex-row invite-heading">
		<h1>Introducing the Court Portal</h1>
		<span>new</span>
	</div>
	<p>
		Your account now has access to the new Luxedo Court Portal — a dedicated home for your court
		content. Build shows around your school's teams and rosters, manage your court, and run
		game-night content all from one place.
	</p>
	<span class="hint">You can come back any time — find Court Portal in the sidebar.</span>
	<div class="button-container">
		<button class="outline-button" onclick={openCourtPortal}>Take me there</button>
		<button class="outline-button alt" onclick={() => closeOverlay()}>Maybe later</button>
	</div>
</div>

<style>
	#court-portal-invite {
		max-width: 40vw;
		padding-bottom: 1.5rem;
	}

	#court-portal-invite.isMobile {
		max-width: unset;
		padding-bottom: 3rem;
	}

	h1 {
		margin: 1rem 0 0 0;
		font-size: var(--h0);
	}

	.isMobile h1 {
		font-size: var(--h1);
	}

	.invite-heading span {
		margin-left: 1rem;
		margin-bottom: 0.2rem;
		color: var(--color-main);
	}

	.invite-heading {
		align-items: flex-end;
		margin-bottom: 1rem;
	}

	.isMobile p {
		line-height: 1.3;
	}

	.hint {
		color: var(--color-main);
	}

	.button-container {
		width: fit-content;
		position: absolute;
		bottom: 0;
	}

	.button-container button {
		margin-right: 1rem;
	}

	.isMobile button {
		padding: 0 1rem;
		margin: 0;
	}

	.isMobile .button-container {
		width: calc(100% - 2rem);
		align-items: center;
		gap: 0;
	}
</style>
